import { render } from "./UiTitle.vue?vue&type=template&id=789b5471&ts=true"
import script from "./UiTitle.vue?vue&type=script&lang=ts"
export * from "./UiTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__